import { useMemo, useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeader from "@/components/base/SectionHeader";
import { channels, topicItems } from "@/mocks/melons";

const STATUS_STYLE: Record<string, string> = {
  实锤推进: "bg-accent-100 text-accent-800 border-accent-200",
  热议中: "bg-primary-100 text-primary-800 border-primary-200",
  等待反转: "bg-secondary-100 text-secondary-800 border-secondary-200",
  尾声: "bg-background-100 text-foreground-600 border-background-200",
  已澄清: "bg-background-100 text-foreground-600 border-background-200",
};

export default function Channels() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () => (active === "all" ? topicItems : topicItems.filter((t) => t.cat === active)),
    [active]
  );

  return (
    <section id="channels" className="bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          eyebrow="栏目分类"
          eyebrowIcon="ri-store-3-line"
          title="按栏目翻一翻本月的瓜"
          desc="从影视到奇趣，不同领域的热点进度一目了然。点击下方栏目可切换分类，各条目的「状态」标注当前讨论处于哪个阶段。"
        />

        <div className="mt-7 flex flex-wrap gap-2">
          {channels.map((c) => {
            const isActive = active === c.key;
            return (
              <button
                key={c.key}
                type="button"
                onClick={() => setActive(c.key)}
                className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-600 text-background-50"
                    : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                <i className={c.icon} />
                {c.name}
                <span className={`text-xs ${isActive ? "text-primary-50/80" : "text-foreground-400"}`}>{c.count}</span>
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((t, i) => (
            <Reveal key={t.id} delay={(i % 3) * 60}>
              <a
                href="#talk"
                className="group flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-0.5 hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-100/70 px-2 py-1 text-xs font-medium text-primary-800">
                    <i className="ri-file-list-3-line" /> {t.source}
                  </span>
                  <span className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLE[t.status]}`}>
                    {t.status}
                  </span>
                </div>
                <h3 className="mt-3 text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-[15px]">
                  {t.title}
                </h3>
                <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-megaphone-line text-foreground-400" /> {t.votes} 参与
                  </span>
                  <span className="flex items-center gap-1.5">
                    热度
                    <span className="flex h-1.5 w-16 items-center overflow-hidden rounded-full bg-background-100">
                      <span className="h-full rounded-full bg-accent-500" style={{ width: `${t.heat}%` }} />
                    </span>
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}